module.exports = __webpack_public_path__ + "media/src/fonts/LoraRegular-207582c7357ef27cacd38fc7b20e683e.woff";